import React from 'react';
import { ConnectionQuality, Track } from 'livekit-client';

import {
  IconMicLine,
  IconMicOffLine,
  IconVideoCameraLine,
  IconVideoCameraOffLine,
  IconAddMediaLine,
  IconScreenCaptureLine,
  IconScreenCaptureSolid,
} from '@smarterservices/smarter-ui';

export function getSourceIcon(source, enabled) {
  switch (source) {
    case Track.Source.Microphone:
      return enabled ? <IconMicLine /> : <IconMicOffLine />;
    case Track.Source.Camera:
      return enabled ? <IconVideoCameraLine /> : <IconVideoCameraOffLine />;
    case Track.Source.ScreenShare:
      return enabled ? <IconScreenCaptureLine /> : <IconScreenCaptureSolid />;
    default:
      return undefined;
  }
}

/**
 * @internal
 */
export function getConnectionQualityIcon(quality) {
  switch (quality) {
    case ConnectionQuality.Excellent:
      return <IconAddMediaLine />;
    case ConnectionQuality.Good:
      return <IconAddMediaLine />;
    case ConnectionQuality.Poor:
      return <IconAddMediaLine />;
    default:
      return <IconAddMediaLine />;
  }
}
